import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Link } from "react-router-dom";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledTooltip, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup, TabContent, TabPane } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import "moment/locale/id";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import PropTypes from "prop-types";
import withRouter from "../../../Components/Common/withRouter";
import { withTranslation } from "react-i18next";
import { api } from "../../../config";
import ModalImage from "react-modal-image";
import CurrencyInput from "react-currency-input-field";
import { QRCodeSVG } from "qrcode.react";

// Formik
import * as Yup from "yup";
import { useFormik, Field, FieldArray } from "formik";
import { useSelector, useDispatch } from "react-redux";
import { setClientSelect, setCompanySelect, setBranchSelect } from "../../../store/app/action";
import { resetSalesState, getSales as onGetSales, addNewSales as onAddNewSales, updateSales as onUpdateSales, deleteSales as onDeleteSales, getSalesLoading, resetSalesCreateState } from "../../../store/sales/action";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { resetApplicantState, getApplicant as onGetApplicant, addNewApplicant as onAddNewApplicant, updateApplicant as onUpdateApplicant, deleteApplicant as onDeleteApplicant, getApplicantLoading } from "../../../store/applicant/action";

import logoDark from "../../../assets/images/logo-dark.png";
import logo from "../../../assets/images/logo-sm.png";
import logoHas from "../../../assets/images/LOGO HAS.png";
import logoCms from "../../../assets/images/LOGO CMS.png";
import logoWAP from "../../../assets/images/LOGO WAP.png";
import logoNSP from "../../../assets/images/LOGO NSP.png";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import handleValidDate from "../../../helpers/utils/handleValidDate";
import { ButtonPrintReceipt, PrintDocReceipt } from "../Management/PrintDocReceipt";
import ExportDoc from "../../../Components/Common/ExportDoc";
import { getTransaction, getTransactionOne } from "../../../store/actions";
import { getAccTrans } from "../../../store/accTrans/action";

const Sales = (props) => {
  const printRef = useRef(null);
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const [indexPage, setIndexPage] = useState(0);
  const [actionType, setActionType] = useState(null);
  const dispatch = useDispatch();

  const {
    clientSelected,
    companySelected,
    branchSelected,
    userData,
    userType,
    userRole,
    isApplicantCreated,
    applicantAdded,
    applicantDocuments,
    applicantDocumentLoading,
    clients,
    clientLoading,
    saless,
    salesAdded,
    isSalesCreated,
    isSalesSuccess,
    loading,
    error,
    companies,
    companyLoading,
    branches,
    branchLoading,
  } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    applicantDocuments: state.ApplicantDocument.applicantDocuments,
    applicantDocumentLoading: state.ApplicantDocument.loading,
    salesAdded: state.Sales.salesAdded,
    saless: state.Sales.saless,
    loading: state.Sales.loading,
    isSalesCreated: state.Sales.isSalesCreated,
    isSalesSuccess: state.Sales.isSalesSuccess,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    paymentMethods: state.PaymentMethod.paymentMethods,
    paymentMethodLoading: state.PaymentMethod.loading,
    paymentTerms: state.PaymentTerm.paymentTerms,
    paymentTermLoading: state.PaymentTerm.loading,
    customers: state.Customer.customers,
    customerAdded: state.Customer.customerAdded,
    isCustomerCreated: state.Customer.isCustomerCreated,
    isCustomerSuccess: state.Customer.isCustomerSuccess,
    customerLoading: state.Customer.loading,
    customerGroups: state.CustomerGroup.customerGroups,
    customerGroupsLoading: state.CustomerGroup.loading,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
    transactionTaxs: state.TransactionTax.transactionTaxs,
    transactionTaxLoading: state.TransactionTax.loading,
    productVarians: state.ProductVarian.productVarians,
    productVarianLoading: state.ProductVarian.loading,
    error: state.Sales.error,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    salesTypes: state.SalesType.salesTypes,
    salesTypeLoading: state.SalesType.loading,
    isApplicantCreated: state.Applicant.isApplicantCreated,
    applicantAdded: state.Applicant.applicantAdded,
  }));

  const [placeDefaultVal, setPlaceDefaultVal] = useState("");
  const [salesList, setSalesList] = useState([]);
  const [salesOriginalList, setSalesOriginalList] = useState([]);
  const [sales, setSales] = useState(null);
  const [info, setInfo] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [customerList, setCustomerList] = useState([]);
  const [customerContactItem, setCustomerContactItem] = useState([]);
  const [customerGroupList, setCustomerGroupList] = useState([]);
  const [paymentMethodList, setPaymentMethodList] = useState([]);
  const [paymentTermList, setPaymentTermList] = useState([]);
  const [taxList, setTaxList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [filterDate, setFilterDate] = useState();
  const [searchType, setSearchType] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [originalFiles, setOriginalFiles] = useState([]);

  const [applicationDoc, setApplicationDoc] = useState(null);
  const [applicationDocImg, setApplicationDocImg] = useState([]);

  const [isEdit, setIsEdit] = useState(false);
  const [isBudget, setIsBudget] = useState(false);
  const [isPayment, setIsPayment] = useState(false);
  const [isEditApllicationDoc, setIsEditApllicationDoc] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [itemName, setItemName] = useState("Print");

  const [modalMedia, setModalMedia] = useState(false);
  const [modalMediaCustomer, setModalMediaCustomer] = useState(false);
  const [salesImg, setSalesImg] = useState([]);
  const [salesImgCustomer, setSalesImgCustomer] = useState([]);

  const [receiptAmount, setReceiptAmount] = useState(0);
  const [receiptDate, setReceiptDate] = useState(0);
  const [receiptCode, setReceiptCode] = useState(0);
  const [branchCode, setBranchCode] = useState(0);
  const [receiptName, setReceiptName] = useState(0);
  const [receiptNote, setReceiptNote] = useState(0);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredSales = saless;
      if (type !== "all") {
        filteredSales = saless.filter((sales) => sales.sales_status && sales.sales_status.name === type);
      }
      setSalesList(filteredSales);
      setSalesOriginalList(filteredSales);
    }
  };

  const sourceTypeData = [
    {
      options: [
        { label: "TIKTOK", value: "TIKTOK" },
        { label: "INSTAGRAM", value: "INSTAGRAM" },
        { label: "FACEBOOK", value: "FACEBOOK" },
        { label: "YOUTUBE", value: "YOUTUBE" },
        { label: "WEBSITE", value: "WEBSITE" },
        { label: "BROSUR", value: "BROSUR" },
        { label: "MEMBER", value: "MEMBER" },
        { label: "KERABAT / TEMAN", value: "KERABAT / TEMAN" },
        { label: "LAIN-LAIN", value: "LAIN-LAIN" },
      ],
    },
  ];

  const toggleType = (type) => {
    let filteredSales = saless;
    if (type !== "all") {
      filteredSales = saless.filter((sales) => sales.typeId === type);
    }
    setSalesList(filteredSales);
  };

  useEffect(() => {
    if (branchSelected && companySelected) {
      handleGetSales(companySelected?.value, branchSelected?.value, false);
    }
  }, [branchSelected, companySelected]);

  const handleGetSales = (companyId, branchId, isSimple) => {
    dispatch(resetSalesState());
    dispatch(onGetSales({ companyId: companyId, branchId: branchId, cashin: true, date: "all" })); //, simple: isSimple
  };

  useEffect(() => {
    if (!isEmpty(saless)) {
      let filteredSales = saless;
      if (activeTypeTab !== "all") {
        filteredSales = saless.filter((sales) => sales.sales_status && sales.sales_status.name === activeTypeTab);
      }
      setSalesList(filteredSales.map((el) => ({ ...el, isChecked: false })));
      setSalesOriginalList(filteredSales);
      setSalesOriginalList();
    }
  }, [saless]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (!isEmpty(branches)) {
      var branchData = [];
      var opt = [];
      (branches || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id, sbum: parseFloat(item.sbum) };
        opt.push(obj);
      });
      var option = { options: opt };
      branchData.push(option);
      setBranchList(branchData);
    }
  }, [branches]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setSales(null);
      setIsEdit(false);
      setIsPayment(false);
      setApplicationDocImg([]);
      setApplicationDoc([]);
      setSelectedFiles([]);
      setOriginalFiles([]);
      setActionType(null);
    } else {
      setModal(true);
    }
  }, [modal]);

  const checkedAll = () => {
    const allChecked = salesList.every((item) => item.isChecked && item.typeId !== 4);
    const updatedData = salesList.map((item) => ({
      ...item,
      isChecked: !allChecked,
    }));

    setSalesList(updatedData);
  };

  const columns = useMemo(() => [
    {
      id: "#",
      Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={salesList.every((item) => item.isChecked)} onChange={checkedAll} />,
      filterable: false,
      Cell: (cellProps) => {
        const data = cellProps.row.original;
        return (
          <div className="hstack gap-2 pe-0 me-0">
            <input
              type="checkbox"
              className="dataCheckbox me-2 form-check-input"
              checked={data.isChecked}
              onChange={() => {
                const updatedData = salesList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                setSalesList(updatedData);
              }}
            />
          </div>
        );
      },
    },
    {
      Header: "No Transaksi",
      accessor: "transaction_no",
      filterable: true,
      Cell: (cell) => {
        const data = cell.row.original;
        let stat;
        let statDeal;
        let statName = data.sales_status && data.sales_status.name;
        let statDealId = data.sales_deal_status && data.sales_deal_status.id;
        switch (statName) {
          case "DRAFT":
            stat = <span className="badge text-uppercase badge-soft-warning">{statName}</span>;
            break;
          case "PENDING":
            stat = <span className="badge text-uppercase badge-soft-secondary">{statName}</span>;
            break;
          case "CONFIRMED":
            stat = <span className="badge text-uppercase badge-soft-info">{statName}</span>;
            break;
          case "PROCESSED":
            stat = <span className="badge text-uppercase badge-soft-success">{statName}</span>;
            break;
          case "SHIPPED":
            stat = <span className="badge text-uppercase badge-soft-primary">{statName}</span>;
            break;
          case "COMPLETED":
            stat = <span className="badge text-uppercase badge-soft-success">{statName}</span>;
            break;
          default:
            stat = <span className="badge text-uppercase badge-soft-danger">{statName}</span>;
            break;
        }

        switch (statDealId) {
          case 3:
            statDeal =
              data.typeId === 3 || data.typeId === 4 ? (
                <span className="badge text-uppercase" style={{ background: "#CFECF7", color: "#687FE5" }}>
                  {"CASH"}
                </span>
              ) : (
                <span className="badge text-uppercase" style={{ background: "#ffe7ff", color: "#ea33f7" }}>
                  {data.sales_deal_status.name}
                </span>
              );
            break;
          case 4:
            statDeal = (
              <span className="badge text-uppercase" style={{ background: "#ede3c5", color: "#806b29" }}>
                {data.sales_deal_status.name}
              </span>
            );
            break;
          case 5:
            statDeal = (
              <span className="badge text-uppercase" style={{ background: "#EAFAEA", color: "#65B741" }}>
                {data.sales_deal_status.name}
              </span>
            );
            break;
          case 6:
            statDeal = (
              <span className="badge text-uppercase" style={{ background: "#FFFDF0", color: "#ffCC55" }}>
                {data.sales_deal_status.name}
              </span>
            );
            break;
          case 7:
            statDeal = <span className="badge text-uppercase badge-soft-info">{data.sales_deal_status.name}</span>;
            break;
          case 8:
            statDeal = (
              <span className="badge text-uppercase" style={{ background: "#E8F9FF", color: "#2cc2c4" }}>
                {data.sales_deal_status.name}
              </span>
            );
            break;
          default:
            statDeal = "";
            break;
        }
        return (
          <div
            className="cursor-pointer"
            onClick={() => {
              setItemName(itemName);
              setReceiptName(data.sales_customer.name);
              setBranchCode(data.sales_branch.branch_code);
              setInfo(data);
              setIsPayment(true);
              setIsEdit(true);
            }}
          >
            <div className="mb-1">
              <span className="fw-semibold">
                {data.transaction_no}
              </span>
            </div>
            <div className="hstack gap-2">
              {stat}
              {statDeal}
            </div>
          </div>
        );
      },
    },
    {
      id: "Tanggal",
      Header: "Tanggal",
      accessor: "bookat",
      filterable: false,
      Cell: (data) => {
        return data.row.original.transactionat ? handleValidDate(data.row.original.transactionat, "D/MM/YYYY") : "";
      },
    },
    {
      Header: "Konsumen",
      accessor: "sales_customer.name",
      filterable: true,
      Cell: (cell) => {
        const data = cell.row.original;
        return (
          <div>
            <div className="mb-1">
              <span className="fw-semibold">
                {cell.value}
              </span>
            </div>
            <div className="hstack gap-2">
              <span className="badge text-uppercase bg-soft-info text-info">
                {data.sales_agent.name}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      Header: "Blok",
      accessor: "sales_detail[0].sales_detail_product.product_block.name",
      filterable: true,
      Cell: (cell) => {
        const data = cell.row.original;
        return (
          data.sales_detail[0]?.sales_detail_product?.product_block?.name && (
            <div className="d-flex">
              <div className="me-3 pt-2" style={{ width: "55px" }}>{`${data.sales_detail[0]?.sales_detail_product?.product_block?.name ?? ""} - ${data.sales_detail[0]?.sales_detail_product?.name ?? ""}`}</div>
            </div>
          )
        );
      },
    },
    {
      id: "Marketing",
      Header: "Marketing",
      accessor: "sales_agent.name",
      filterable: true,
    },
    {
      id: "IdentitasDiri",
      Header: <div style={{ minWidth: "100px" }}>Identitas Diri</div>,
      accessor: "sales_file",
      filterable: false,
      Cell: (cell) => {
        const data = (cell.value || []).filter(f => f.type === "Identitas Diri");
        if (data.length > 0) {
          return <div>
            {data.map((f, i) => {
              return (
                <Link key={i} to={`${api.MEDIA_URL}/media/${f.filename}`} target="_blank" className={"avatar-xs user-profile-image"}>
                  <i className="ri-file-download-line fs-3 text-success"></i>
                </Link>
              );
            })}
          </div>;
        }
        else
        {
          return <i className="ri-close-circle-line fs-3 text-danger"></i>
        }
      },
    },
    {
      id: "NPWP",
      Header: <div style={{ minWidth: "100px" }}>NPWP</div>,
      accessor: "sales_file",
      filterable: false,
      Cell: (cell) => {
        const data = (cell.value || []).filter(f => f.type === "NPWP");
        if (data.length > 0) {
          return <div>
            {data.map((f, i) => {
              return (
                <Link key={i} to={`${api.MEDIA_URL}/media/${f.filename}`} target="_blank" className={"avatar-xs user-profile-image"}>
                  <i className="ri-file-download-line fs-3 text-success"></i>
                </Link>
              );
            })}
          </div>;
        }
        else
        {
          return <i className="ri-close-circle-line fs-3 text-danger"></i>
        }
      },
    },
    {
      id: "SP3K",
      Header: <div style={{ minWidth: "100px" }}>SP3K</div>,
      accessor: "sales_file",
      filterable: false,
      Cell: (cell) => {
        const data = (cell.value || []).filter(f => f.type === "SP3K");
        if (data.length > 0) {
          return <div>
            {data.map((f, i) => {
              return (
                <Link key={i} to={`${api.MEDIA_URL}/media/${f.filename}`} target="_blank" className={"avatar-xs user-profile-image"}>
                  <i className="ri-file-download-line fs-3 text-success"></i>
                </Link>
              );
            })}
          </div>;
        }
        else
        {
          return <i className="ri-close-circle-line fs-3 text-danger"></i>
        }
      },
    },
    {
      id: "SPT",
      Header: <div style={{ minWidth: "100px" }}>SPT Tahunan</div>,
      accessor: "sales_file",
      filterable: false,
      Cell: (cell) => {
        const data = (cell.value || []).filter(f => f.type === "SPT Tahunan");
        if (data.length > 0) {
          return <div>
            {data.map((f, i) => {
              return (
                <Link key={i} to={`${api.MEDIA_URL}/media/${f.filename}`} target="_blank" className={"avatar-xs user-profile-image"}>
                  <i className="ri-file-download-line fs-3 text-success"></i>
                </Link>
              );
            })}
          </div>;
        }
        else
        {
          return <i className="ri-close-circle-line fs-3 text-danger"></i>
        }
      },
    },
    {
      id: "Penghasilan",
      Header: <div style={{ minWidth: "100px" }}>Penghasilan</div>,
      accessor: "sales_file",
      filterable: false,
      Cell: (cell) => {
        const data = (cell.value || []).filter(f => f.type === "Keterangan Penghasilan");
        if (data.length > 0) {
          return <div>
            {data.map((f, i) => {
              return (
                <Link key={i} to={`${api.MEDIA_URL}/media/${f.filename}`} target="_blank" className={"avatar-xs user-profile-image"}>
                  <i className="ri-file-download-line fs-3 text-success"></i>
                </Link>
              );
            })}
          </div>;
        }
        else
        {
          return <i className="ri-close-circle-line fs-3 text-danger"></i>
        }
      },
    },
    {
      id: "Rumah",
      Header: <div style={{ minWidth: "100px" }}>Kepemilikan Rumah</div>,
      accessor: "sales_file",
      filterable: false,
      Cell: (cell) => {
        const data = (cell.value || []).filter(f => f.type === "Keterangan Belum Memiliki Rumah");
        if (data.length > 0) {
          return <div>
            {data.map((f, i) => {
              return (
                <Link key={i} to={`${api.MEDIA_URL}/media/${f.filename}`} target="_blank" className={"avatar-xs user-profile-image"}>
                  <i className="ri-file-download-line fs-3 text-success"></i>
                </Link>
              );
            })}
          </div>;
        }
        else
        {
          return <i className="ri-close-circle-line fs-3 text-danger"></i>
        }
      },
    },

    {
      id: "PPJB",
      Header: <div style={{ minWidth: "100px" }}>PPJB</div>,
      accessor: "sales_file",
      filterable: false,
      Cell: (cell) => {
        const data = (cell.value || []).filter(f => f.type === "PPJB");
        if (data.length > 0) {
          return <div>
            {data.map((f, i) => {
              return (
                <Link key={i} to={`${api.MEDIA_URL}/media/${f.filename}`} target="_blank" className={"avatar-xs user-profile-image"}>
                  <i className="ri-file-download-line fs-3 text-success"></i>
                </Link>
              );
            })}
          </div>;
        }
        else
        {
          return <i className="ri-close-circle-line fs-3 text-danger"></i>
        }
      },
    },
    {
      id: "PK",
      Header: <div style={{ minWidth: "100px" }}>Perjanjian Kredit</div>,
      accessor: "sales_file",
      filterable: false,
      Cell: (cell) => {
        const data = (cell.value || []).filter(f => f.type === "Perjanjian Kredit");
        if (data.length > 0) {
          return <div>
            {data.map((f, i) => {
              return (
                <Link key={i} to={`${api.MEDIA_URL}/media/${f.filename}`} target="_blank" className={"avatar-xs user-profile-image"}>
                  <i className="ri-file-download-line fs-3 text-success"></i>
                </Link>
              );
            })}
          </div>;
        }
        else
        {
          return <i className="ri-close-circle-line fs-3 text-danger"></i>
        }
      },
    },
    {
      id: "Bapeda",
      Header: <div style={{ minWidth: "100px" }}>SK Bapeda</div>,
      accessor: "sales_file",
      filterable: false,
      Cell: (cell) => {
        const data = (cell.value || []).filter(f => f.type === "Surat Kuasa Bapeda");
        if (data.length > 0) {
          return <div>
            {data.map((f, i) => {
              return (
                <Link key={i} to={`${api.MEDIA_URL}/media/${f.filename}`} target="_blank" className={"avatar-xs user-profile-image"}>
                  <i className="ri-file-download-line fs-3 text-success"></i>
                </Link>
              );
            })}
          </div>;
        }
        else
        {
          return <i className="ri-close-circle-line fs-3 text-danger"></i>
        }
      },
    },
    {
      id: "Old",
      Header: <div>Lain-lain</div>,
      accessor: "sales_file",
      filterable: false,
      Cell: (cell) => {
        const data = (cell.value || []).filter(f => f.type === "" || !f.type);
        if (data.length > 0) {
          return <div>
            {data.map((f, i) => {
              return (
                <Link key={i} to={`${api.MEDIA_URL}/media/${f.filename}`} target="_blank" className={"avatar-xs user-profile-image"}>
                  <i className="ri-file-download-line fs-3 text-success"></i>
                </Link>
              );
            })}
          </div>;
        }
        else
        {
          return <i className="ri-close-circle-line fs-3 text-danger"></i>
        }
      },
    },
    {
      id: "Pemberkasan",
      Header: <div style={{ minWidth: "100px" }}>Dokumen Pemberkasan</div>,
      accessor: "sls_appl",
      filterable: false,
      Cell: (cell) => {
        return <div >
          {(cell?.value?.applicant_file || []).map((f, i) => {
            return (
              <div key={i}>
                <div className="d-flex mb-3">
                  <div className="me-2">
                    {f.mimetype === "image/jpg" || f.mimetype === "image/png" || f.mimetype === "image/jpeg" ? (
                      <ModalImage showRotate={true} small={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}-w-50`} large={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}`} alt={info.name} className="img-thumbnail avatar-xs user-profile-image" />
                    ) : (
                      <Link to={`${api.MEDIA_URL}/media/${f.filename}`} target="_blank" className={"img-thumbnail avatar-xs user-profile-image"}>
                        <i className="ri-file-pdf-line fs-3 text-danger"></i>
                      </Link>
                    )}
                  </div>
                  <div className="text-truncate">{f.originalname}</div>
                </div>
              </div>
            );
          })}
        </div>;
      },
    },
    {
      id: "Proyek",
      Header: "Project",
      accessor: "sales_branch.name",
      filterable: true,
    },
  ],
    [salesList, userRole, userType, actionType],
  );

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: salesList,
      defaultColumn: { Filter: null },
      initialState: {
        hiddenColumns: ["Status", "Proyek", "Booking", "Marketing"],
        pageIndex: indexPage,
        pageSize: 25,
        selectedRowIds: 0,
        sortBy: [
          {
            id: "Tanggal",
            desc: true,
          },
        ],
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect,
  );

  useEffect(() => {
    setIndexPage(pageIndex);
  }, [pageIndex]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const countSearch = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 600);

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    const param = {
      title: searchValue,
      type: searchType.value ?? "",
      startat: startat,
      endat: endat,
      branchId: branchSelected.value ?? "",
      cashin: true
    };
    dispatch(onGetSales(param));
  }

  function handleResetFilter() {
    setFilterDate(null);
    setSearchType("");
    setSearchValue("");
    handleGetSales(branchSelected?.companyId, branchSelected?.value, true);
  }

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  function numberToWords(input) {
    const number = Number(input);

    if (isNaN(number)) {
      return "Input harus angka yang valid (contoh: 6500000 atau '6500000')";
    }

    if (number < 0) {
      return "Input harus non-negatif";
    }

    const num = Math.floor(number);

    if (num === 0) {
      return "Nol Rupiah";
    }

    const satuan = ["", "Satu", "Dua", "Tiga", "Empat", "Lima", "Enam", "Tujuh", "Delapan", "Sembilan"];
    const belasan = ["Sepuluh", "Sebelas", "Dua Belas", "Tiga Belas", "Empat Belas", "Lima Belas", "Enam Belas", "Tujuh Belas", "Delapan Belas", "Sembilan Belas"];
    const puluhan = ["", "", "Dua Puluh", "Tiga Puluh", "Empat Puluh", "Lima Puluh", "Enam Puluh", "Tujuh Puluh", "Delapan Puluh", "Sembilan Puluh"];
    const skala = ["", "Ribu", "Juta", "Miliar", "Triliun", "Kuadriliun", "Kuintiliun"];

    function convertLessThanThousand(n) {
      if (n === 0) return "";
      if (n < 10) return satuan[n];
      if (n < 20) return belasan[n - 10];
      if (n < 100) {
        const p = puluhan[Math.floor(n / 10)];
        const s = satuan[n % 10];
        return p + (s ? " " + s : "");
      }
      const ratus = satuan[Math.floor(n / 100)];
      const sisa = n % 100;
      let hasil = ratus + " Ratus";
      if (sisa > 0) hasil += " " + convertLessThanThousand(sisa);
      return hasil;
    }

    let parts = [];
    let temp = num;
    while (temp > 0) {
      parts.push(temp % 1000);
      temp = Math.floor(temp / 1000);
    }

    let result = [];
    for (let i = parts.length - 1; i >= 0; i--) {
      const val = parts[i];
      if (val === 0) continue;

      let chunk = convertLessThanThousand(val);
      if (i > 0) {
        chunk += " " + skala[i];
      }
      if (chunk) result.push(chunk);
    }

    let final = result.join(" ");

    final = final.replace(/^Satu Ribu\b/, "Seribu");

    final = final.replace(/Satu Ratus(?=.*(Juta|Miliar|Triliun|Kuadriliun|Kuintiliun))/g, "Seratus");

    return final + " Rupiah";
  }

  const [isDownloading, setIsDownloading] = useState(false);

  // Core download function for a single file URL
  const downloadSingleFile = async (url, fileName) => {
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`Failed to fetch ${url}`);

      // Convert response into a raw data Blob
      const blob = await response.blob();

      // Create a temporary object URL pointing to the Blob
      const objectUrl = window.URL.createObjectURL(blob);

      // Programmatically create and trigger a hidden anchor link
      const anchor = document.createElement('a');
      anchor.href = objectUrl;
      anchor.download = fileName || 'downloaded-file';

      document.body.appendChild(anchor);
      anchor.click();

      // Cleanup DOM element and release object URL memory
      document.body.removeChild(anchor);
      window.URL.revokeObjectURL(objectUrl);
    } catch (error) {
      console.error(`Error downloading ${fileName}:`, error);
    }
  };

  // Main click handler to process all files asynchronously
  const handleDownloadAll = () => {
    setIsDownloading(true);
    salesList.forEach(file => {
      (file.sales_file || []).forEach(f => {
        let fileUrl = `${api.MEDIA_URL}/media/${f.filename}`;
        let fileName = f.originalname;
        downloadSingleFile(fileUrl, fileName);
      });
    })

    setIsDownloading(false);
  };

  const scrollRef = useRef(null);

  const [isDown, setIsDown] = useState(false);
  const [startX, setStartX] = useState(0);
  const [startY, setStartY] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [scrollTop, setScrollTop] = useState(0);

  const handleMouseDown = (e) => {
    setIsDown(true);

    const rect = scrollRef.current.getBoundingClientRect();

    setStartX(e.clientX - rect.left);
    setStartY(e.clientY - rect.top);

    setScrollLeft(scrollRef.current.scrollLeft);
    setScrollTop(scrollRef.current.scrollTop);
  };

  const handleMouseLeave = () => {
    setIsDown(false);
  };

  const handleMouseUp = () => {
    setIsDown(false);
  };

  const handleMouseMove = (e) => {
    if (!isDown) return;

    e.preventDefault();

    const rect = scrollRef.current.getBoundingClientRect();

    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const walkX = (x - startX) * 1.5; // speed horizontal
    const walkY = (y - startY) * 1.5; // speed vertical

    scrollRef.current.scrollLeft = scrollLeft - walkX;
    scrollRef.current.scrollTop = scrollTop - walkY;
  };

  document.title = "Kasir | PESONA KAHURIPAN";
  
  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={salesList} />
      <Container fluid>
        <BreadCrumb title="Penjualan" pageTitle="Penjualan" loading={loading}>
          <div className="flex-shrink-0">

            <button className="btn btn-info"
              onClick={handleDownloadAll}
              disabled={isDownloading}>{isDownloading ? 'Downloading All Files...' : 'Download'}
            </button>
          </div>
        </BreadCrumb>
        <Row>
          <Col xxl={12}>
            <Card>
              <CardBody className="pt-1">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                          setSalesList(saless);
                          setSalesOriginalList(saless);
                          setSearchType("");
                          setFilterDate(null);
                        }}
                        href="#"
                      >
                        <i className="ri-file-list-3-line me-1 align-bottom fs-14"></i> SEMUA PENJUALAN
                      </NavLink>
                    </NavItem>
                    {/* <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")} onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#">
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT </NavLink>
                    </NavItem> */}
                    {/* <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "CONFIRMED");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> CONFIRMED
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "PROCESSED");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> PROCESSED
                      </NavLink>
                    </NavItem> */}
                    {/* <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "5" }, "fw-semibold")} onClick={() => {
                          toggleTab("5", "SHIPPED");
                        }}
                        href="#">
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> SHIPPED</NavLink>
                    </NavItem> */}
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "6" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("6", "COMPLETED");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> AKAD
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "7" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("7", "CANCELED");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> CANCELED
                      </NavLink>
                    </NavItem>
                    {/* <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "8" }, "fw-semibold")} onClick={() => {
                          toggleTab("8", "RETURNED");
                        }}
                        href="#">
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> RETURNED</NavLink>
                    </NavItem> */}
                    {/* <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "9" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("9", "REFUNDED");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> REFUNDED
                      </NavLink>
                    </NavItem> */}
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <Row>
                        <Col sm={1}>
                          <div className="me-2 mb-3 col-12">
                            <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                              {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                <option key={pageSize} value={pageSize}>
                                  {pageSize}
                                </option>
                              ))}
                            </select>
                          </div>
                        </Col>
                        <Col sm={4}>
                          <div className="me-2 mb-3 d-inline-block col-12">
                            <input
                              id="search-bar-0"
                              type="text"
                              className="form-control search"
                              onChange={(e) => {
                                setSearchValue(e.target.value);
                                onChange(e.target.value);
                                gotoPage(0);
                              }}
                              placeholder={`${countSearch} Search...`}
                              value={searchValue ?? ""}
                            />
                          </div>
                        </Col>
                        <Col sm={3}>
                          <div className="me-2 mb-3 col-12">
                            <Flatpickr
                              className="form-control"
                              id="datepicker-publish-input"
                              placeholder="Pilih Tanggal"
                              options={{
                                mode: "range",
                                dateFormat: "Y/m/d",
                              }}
                              value={filterDate}
                              onChange={(selectedDates, dateStr) => {
                                setFilterDate(dateStr);
                              }}
                            />
                          </div>
                        </Col>
                        <Col sm={2}>
                          <div className="hstack gap-2">
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100 fw-semibold"
                              onClick={() => {
                                handleFilter();
                              }}
                            >
                              <i className="ri-search-line align-bottom fs-16"></i>
                            </button>
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleResetFilter();
                              }}
                            >
                              <i className="mdi mdi-restore align-bottom fs-18"></i>
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Row>
                  <div
                    className="table-responsive table-card table-container-sticky mb-1 table-scroll"
                    ref={scrollRef}
                    onMouseDown={handleMouseDown}
                    onMouseLeave={handleMouseLeave}
                    onMouseUp={handleMouseUp}
                    onMouseMove={handleMouseMove}
                    // style={{ cursor: isDown ? "grabbing" : "grab", userSelect: isDown ? "none" : "auto" }}
                    style={{
                      overflow: "auto",
                      maxHeight: "calc(100vh - 340px)",
                      cursor: isDown ? "grabbing" : "grab",
                      //userSelect: isDown ? "none" : "auto",
                    }}
                  >
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} value={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>

                <Modal id="showModal" isOpen={modal} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Edit Penjualan" : "Form Penjualan"}
                  </ModalHeader>
                  <ModalBody>

                  </ModalBody>
                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => {
                          toggle();
                        }}
                      >
                        TUTUP
                      </button>
                    </div>
                  </div>
                </Modal>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
Sales.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(Sales));
